module.exports = __webpack_public_path__ + "img/bjhhNvJS.f218f5e3.svg";